<template>
  <div style="margin: 15px; margin-right: 30px;">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="100px"
    >
      <el-form-item
        label="通知标题"
        prop="title"
      >
        <el-input
          v-model.trim="form.title"
          placeholder="请输入通知标题"
          @change="(value)=>{form.title = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="通知内容"
        prop="noticeContent"
      >
        <el-input
          v-model="form.noticeContent"
          type="textarea"
          :rows="10"
          placeholder="请输入通知内容"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import { addNoteOrSMSManage } from "@/api/news";
export default {
  name: "NoteManageAdd",
  data() {
    return {
      form: {
        noticeType: 1,
        title: "",
        noticeContent: ""
      },
      rules: {
        title: [
          { required: true, message: "请输入通知标题", trigger: "blur" },
          { min: 1, max: 255, message: '长度在 1 到 255个字符', trigger: 'blur' }
          ],
        noticeContent: [
          { required: true, message: "请输入通知内容", trigger: "blur" },
          { min: 1, max: 255, message: '长度在 1 到 255个字符', trigger: 'blur' }
        ]
      }
    };
  },
  created() {},
  methods: {
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          addNoteOrSMSManage(this.form)
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherComplete");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherComplete");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}


</style>
